export default __webpack_public_path__ + "static/media/minidisko-maskot.e96248dd.svg";